import { T, __ } from 'stylewhere/i18n'
import { ApiError } from './ApiError'

class ConnectionError extends ApiError {
  statusCode = 0
  message = __(T.error.connection)
}

export default ConnectionError
